<template>
	<fragment>
		<!-- Staff view -->
		<template v-if="isStaff">
			<template v-if="!isEditable()">
				<!-- Read-only view for staff after sending/signing -->
				<span class="value contentBlock textInputSmall textCenter">{{ formattedValue }}</span>
			</template>
			<template v-else>
				<!-- Editable view for staff -->
				<input
					id="returned_percentage"
					v-model="contract.returned_percentage"
					name="returned_percentage"
					type="text"
					class="textInputSmall textCenter"
					placeholder="N/A"
					maxlength="10"
				/>
			</template>
		</template>
		<!-- Customer view -->
		<template v-else>
			<span class="value contentBlock textInputSmall textCenter">{{ formattedValue }}</span>
		</template>
	</fragment>
</template>

<script>
	import { Fragment } from 'vue-frag'
	import contractState from '@/mixins/contractState'

	export default {
		name: 'ReturnedFlatPercentage',
		components: {
			Fragment
		},
		mixins: [contractState],
		props: {
			contract: {
				type: Object,
				required: true
			}
		},
		computed: {
			/**
			 * The formatted value
			 * @returns {string} The formatted value
			 */
			formattedValue() {
				const value = this.contract?.returned_percentage?.toString().trim()
				return value?.length > 0 ? value : 'N/A'
			}
		}
	}
</script>

<style scoped>
	.textInputSmall {
		width: 60px;
	}
</style>
